<template>
   <div class="page-container-web dv-main-login">
        <div class="dv-container-form">
            <LoginFormComponent :type="1" 
                                :serverResponse="serverResponse"
                                :loading="loading"
                                class="container-form"
                                v-on:onLogin="fnOnLogin">                
            </LoginFormComponent>
        </div>
   </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import LoginFormComponent from './LoginFormComponent.vue';
import LoginService from '@/core/services/login/LoginService';
import { ISesionApp } from '@/core/model/sesion/ISesionApp';
import { eAppPaths, eRolAppUsuario } from '@/core/model/GloblasEnum';
import { useRouter } from 'vue-router';

const route = useRouter();
const loading = ref(false);
let serverResponse = ref({tipo:0,msg:''});
const loginService:LoginService = useServicesFactoryStore().getLoginService;
const evalServerResponse = (d:any)=>
{
  serverResponse.value = d;
}
const fnOnLogin = async (values:any) =>
{
    loading.value = true;  
    if(values)
    {
     serverResponse.value.tipo = 0;   
     serverResponse.value.msg = '';      
     const sesion:ISesionApp|null = await loginService.LoginEmployee(values,evalServerResponse);     
     if(sesion != null && sesion.Gid)
     {
      
       const sesionSaved = await loginService.SesionEmpleado(sesion);
       if(sesionSaved)
       {
        sendToHome(sesionSaved);
       }
     }
    }
    loading.value = false;  
};
const sendToHome = (sesion: ISesionApp) =>
{
  if(sesion && sesion.getId() && sesion.Type === eRolAppUsuario.Empleado) 
  {    
    route.replace({ name: eAppPaths.homeEmpleado });
  } 
  if(sesion && sesion.getId() && sesion.Type === eRolAppUsuario.Cliente) 
  {    
    route.replace({ name: eAppPaths.homeCliente });
  } 
};
onMounted(async ()=>
{        
  const sesion:ISesionApp|null = await loginService.getSession();   
  if(sesion)
  {           
    sendToHome(sesion);        
  }  
}); 
</script>
